import postLogin from './postLogin';
import getUser from './getUser';

export default {
  postLogin,
  getUser,
};
